<script lang="ts">
import { defineComponent, ref, PropType, computed, watchEffect } from 'vue'

export default defineComponent({
  props: {
    colors: Array as PropType<{ color: string; taken: boolean }[] | null>,
  },
  emits: ['join'],
  setup(props) {
    const name = ref(localStorage.getItem('myname') || '')
    watchEffect(() => {
      localStorage.setItem('myname', name.value)
    })
    const allTaken = computed(
      () => props.colors && props.colors.every((c) => c.taken)
    )
    return { name, allTaken }
  },
})
</script>

<template>
  <div class="all">
    <h1>Snake</h1>
    <label> Name: <input v-model="name" /> </label>
    <template v-if="colors && name.length > 0">
      <h2>Choose a color to begin:</h2>
      <div v-for="color in colors" class="colordiv">
        <button
          :disabled="!allTaken && color.taken"
          @click="$emit('join', { color: color.color, name })"
        >
          {{ color.color }}{{ color.taken ? ' (taken)' : '' }}
        </button>
      </div>
    </template>
    <template v-else-if="name.length > 0">
      <h2>Connecting to server...</h2>
    </template>

    <div>
      <a href="/spectate">Spectator mode</a>
    </div>

    <ul>
      <li>Goal: be the longest snake</li>
      <li>Use arrows or WASD to move</li>
      <li>Press F to go full screen</li>
      <li>Press B to view the whole game</li>
      <li>Press X if one of your arrow keys gets stuck</li>
    </ul>
  </div>
</template>

<style scoped>
.all {
  text-align: center;
}

.colordiv {
  margin: 3px;
}
</style>
